/*!
 * Copyright (c) REWE Digital GmbH
 */
import { h, Host } from "@stencil/core";
/**
 * Filter Page.
 */
export class VxSelectedFilter {
    constructor() {
        this.deleteAllButtonLabel = 'Alles löschen';
        this.filter = undefined;
        this.isManufacturerListing = false;
    }
    /**
     * Handle Tag clicked.
     */
    handleTagClicked(filterId, optionId) {
        setTimeout(() => {
            this.filterChanged.emit({
                filterId: filterId,
                filterValueId: optionId,
                filterRemoved: true,
            });
        }, 250);
    }
    /**
     * Handle key press event.
     */
    handleKeyPress(event) {
        if ([' ', 'Escape'].includes(event.key)) {
            this.clearFilter.emit();
        }
    }
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        var _a;
        let selectedCount = 0;
        const renderTags = (_a = this.filter) === null || _a === void 0 ? void 0 : _a.filter((filter) => {
            var _a, _b;
            return (((_a = filter.id) === null || _a === void 0 ? void 0 : _a.startsWith('p')) || (((_b = filter.id) === null || _b === void 0 ? void 0 : _b.startsWith('b')) && !this.isManufacturerListing));
        }).map((filter) => {
            var _a;
            return (_a = filter === null || filter === void 0 ? void 0 : filter.options) === null || _a === void 0 ? void 0 : _a.filter((option) => {
                return option.selected;
            }).map((option) => {
                selectedCount++;
                return (h("vx-selected-filter-tag", { label: option.label, onClick: () => this.handleTagClicked(filter.id, parseInt(option.id, 10)) }));
            });
        }).filter(filter => (filter === null || filter === void 0 ? void 0 : filter.length) > 0);
        return (h(Host, null, h("div", { class: 'vx-selected-filter' }, renderTags), selectedCount > 1 &&
            h("button", { class: 'vx-selected-filter__button', onClick: () => this.clearFilter.emit(), onKeyDown: this.handleKeyPress.bind(this) }, this.deleteAllButtonLabel)));
    }
    static get is() { return "vx-selected-filter"; }
    static get encapsulation() { return "scoped"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-selected-filter.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-selected-filter.css"]
        };
    }
    static get properties() {
        return {
            "deleteAllButtonLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Label delete all button."
                },
                "attribute": "delete-all-button-label",
                "reflect": false,
                "defaultValue": "'Alles l\u00F6schen'"
            },
            "filter": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "Array<{\n        id: string\n        options?: Array<{\n            id: string\n            selected: boolean\n            label: string\n        }>\n    }>",
                    "resolved": "{ id: string; options?: { id: string; selected: boolean; label: string; }[]; }[]",
                    "references": {
                        "Array": {
                            "location": "global",
                            "id": "global::Array"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "The filter parameters."
                }
            },
            "isManufacturerListing": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Bool if Listing Page is manufacturer Listing."
                },
                "attribute": "is-manufacturer-listing",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "filterChanged",
                "name": "filterChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Change filter event."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "clearFilter",
                "name": "clearFilter",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Clear filter event."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
}
//# sourceMappingURL=vx-selected-filter.js.map
